import React from "react";
import "./Loader.scss";
import regbanner from "../../../assets/icons/progresslogo.png";
import { errorMessage } from "../../utils/errorMessage";


export interface ILoaderProps {
	color?: 'grey' | 'blue';
	size: 18 | 20 | 50 | 100;
}

const Loader: React.FC<ILoaderProps> = (props: ILoaderProps) => {
	const color = props.color || "grey";
	return (
		<div className="loader-container">
			<img
				src={regbanner}
				className="verified-img"
				alt="Loading"
			/>
			<p className="loader-text">
				{errorMessage.loaderMsg}
			</p>
		</div>
	);
};

export default Loader;
